export const SIWAVE = 'SIwave',
  HFSS = 'HFSS',
  POWERSI = 'PowerSI',
  BUILD_IN = "Default",
  PSI = 'SIwavePSI',
  ANSYS = 'Ansys',
  SIWAVE_HFSS = 'SIwave+HFSS';